import { makeShippingProtectionClaimLoader } from '~/utils/routing';

export const { loader, useLoaderData: useEditAddressData } =
  makeShippingProtectionClaimLoader(({ context }) => ({
    address: context.address ?? context.order.shippingAddress,
  }));
